module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3VaCA"))).then(() => parcelRequire('hEqeo'));